import React, { Component } from "react";
import InfoPage from "../containers/InfoPage";
import ThemeInfoPage from "../theme/ThemeInfoPage";

import { withTranslation } from "react-i18next";

class EnterSitePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      reply: {},
      customTheme: false,
      inited: false,
    };
  }

  componentDidMount() {
    let { i18n } = this.props;
    fetch("on_info", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.location.state.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.userLanguage === "English") {
          i18n.changeLanguage("en");
        }
        if (reply.userLanguage === "French") {
          i18n.changeLanguage("fr");
        }
        if (reply.userLanguage === "Spanish") {
          i18n.changeLanguage("es");
        }
        this.setState({ reply: reply });
        if (reply.themeData.length > 0) {
          window.sco_custom_theme = JSON.parse(reply.themeData);
          this.setState({ customTheme: true });
        } else {
          this.setState({ customTheme: false });
        }
        this.setState({ inited: true });
      })
      .catch((error) => {
        this.setState({
          errorString: "The server responded with a status of " + error.message,
        });
        this.setState({ inited: true });
      });
  }

  render() {
    return (
      <div>
        {this.state.inited && !this.state.customTheme && (
          <InfoPage
            history={this.props.history}
            secureToken={this.props.location.state.secureToken}
            errorString={this.state.errorString}
            reply={this.state.reply}
          />
        )}
        {this.state.inited && this.state.customTheme && (
          <ThemeInfoPage
            history={this.props.history}
            secureToken={this.props.location.state.secureToken}
            errorString={this.state.errorString}
            reply={this.state.reply}
          />
        )}
      </div>
    );
  }
}

export default withTranslation()(EnterSitePage);
